<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!stockId">  {{'app.create' | translate}}</span>
    <span class="panel-title" *ngIf="stockId">  {{'app.editTile' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>

      <form #f="ngForm" *ngIf="displayMode==2" novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (itemId.dirty || itemId.touched || f.submitted)  && itemId.valid, 'has-error' : (itemId.dirty || itemId.touched || f.submitted)  && itemId.invalid}">
              <label class="control-label">{{'giveaways.giveaways' | translate}} </label><br />
              <span class="ui-fluid">
                <p-dropdown [options]="giveawayItems"
                            name="itemId" #itemId="ngModel"
                            styleClass="wid100"
                            placeholder="{{'giveaways.giveaways' | translate}}"
                            emptyFilterMessage="No results found"
                            showClear="true"
                            required
                            [styleClass]="form-control"
                            [(ngModel)]="stock.giveawayItem"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>
              </span>
              <div *ngIf="(itemId.dirty || itemId.touched || f.submitted)  && itemId.invalid" class="jquery-validate-error help-block">
                {{'generalValidations.requiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (quantity.dirty || quantity.touched || f.submitted)  && quantity.valid, 'has-error' : (quantity.dirty || quantity.touched || f.submitted)  && quantity.invalid}">
              <label class="control-label">{{'giveaways.quantity' | translate}} </label>
              <input class="form-control" placeholder="{{'giveaways.quantity' | translate}}" required
                     name="quantity" #quantity="ngModel"
                     [(ngModel)]="stock.quantity" type="number">
              <div *ngIf="(quantity.dirty || quantity.touched || f.submitted)  && quantity.errors?.required" class="jquery-validate-error help-block">
                {{'generalValidations.requiredField' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" [disabled]="f.invalid">{{'app.save' | translate}}</button>
        </div>
      </form>

    </div>
  </div>
</div>


<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




